import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import variables from "../../../constants/assets/variables";
import { capitalizeFirstLetter } from "../../../utils";
import Permission from "../../Common/Permission";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";

let allActions = ["view/edit", "enable", "Sub Issue Types"];
const IssueTypeActionBar = ({
  handleBlur,
  right,
  top,
  issueId,
  enabled,
  openEnableDisableModal,
}) => {
  const history = useHistory();
  const allPermissionActions =
    MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DASHBOARD];

  React.useEffect(() => {
    if (right && top) {
      document.getElementById("actionsBox").style.right = right + "px";
      document.getElementById("actionsBox").style.top = top + "px";
      document.getElementById("layer-mask").style.opacity = 1;
    }
  }, [right, top]);

  const handleActionClick = (type) => {
    if (type === "view/edit") {
      history.push(`/issue-types/${issueId}/view`);
    } else if (type === "enable") {
      handleBlur();
      openEnableDisableModal();
    } else if (type === "Sub Issue Types") {
      history.push(`/sub-issue-types/${issueId}`);
    }
  };
  return (
    <LayerMask id="layer-mask" onClick={handleBlur}>
      {" "}
      <IssueTypeActions onClick={(e) => e.stopPropagation()} id="actionsBox">
        {" "}
        {allActions.map((action, index) => {
          if (action === "enable") {
            return (
              <>
                <Permission requiredPerms={[allPermissionActions.UPDATE]}>
                  <li
                    onClick={() => {
                      handleActionClick(action);
                    }}
                    key={index}
                  >
                    {" "}
                    {capitalizeFirstLetter(enabled ? "disable" : "enable")}{" "}
                  </li>
                </Permission>
              </>
            );
          } else {
            return (
              <Permission
                requiredPerms={
                  action === "view/edit"
                    ? [allPermissionActions.DETAIL]
                    : [allPermissionActions.LIST_SUB_ISSUE_TYPE]
                }
              >
                <li
                  onClick={() => {
                    handleActionClick(action);
                  }}
                  key={index}
                >
                  {" "}
                  {capitalizeFirstLetter(action.split("_").join(" "))}{" "}
                </li>
              </Permission>
            );
          }
        })}{" "}
      </IssueTypeActions>{" "}
    </LayerMask>
  );
};

const LayerMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  opacity: 0;
`;
const IssueTypeActions = styled.ul`
  list-style-type: none;
  position: absolute;
  background: #fff;
  border: 0.5px solid ${variables.grey100};
  padding: unset;
  max-width: 150px;
  border-radius: 8px;
  filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
  li {
    padding: 8px;
    cursor: pointer;
    &:not(:last-child) {
      border-bottom: 1px solid ${variables.grey100};
    }
  }
`;
export default IssueTypeActionBar;
